export const defaultColumns = [
  { label: 'Código', value: 'reference_number', className: 'w-0' },
  { label: 'Status', value: 'status' },
  { label: 'Motivo', value: 'reason' },
  { label: 'Visto por último (Externo)', value: 'company_last_viewed_at' },
  { label: 'Assunto', value: 'subject_line' },
  { label: 'Atribuído para', value: 'responsible' },
  { label: 'Autor', value: 'creator' },
  { label: 'Quando', value: 'created_at' },
  { label: 'Ações', value: 'actions', className: 'w-0' },
]
